<template>
  <v-container>
    <h1 class="text-center">Commands</h1>
    <v-toolbar flat>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-toolbar>

    <!-- Desktop: Data Table -->
    <v-data-table
      v-if="!$vuetify.breakpoint.smAndDown"
      :search="search"
      :headers="headers"
      :items="commands"
      sort-by="calories"
      class="elevation-1"
    >
    </v-data-table>

    <!-- Mobile: Card List -->
    <template v-else>
      <v-card
        v-for="item in filteredCommands"
        :key="item.command"
        class="mb-3"
        outlined
      >
        <v-card-title class="d-flex justify-space-between align-center py-2">
          <span class="cmd-label">{{ item.command }}</span>
          <v-chip x-small class="ml-2">{{ item.perm }}</v-chip>
        </v-card-title>
        <v-card-text class="pt-0">
          <div v-if="item.alias && item.alias.length" class="caption mt-1">
            Alias: {{ Array.isArray(item.alias) ? item.alias.join(', ') : item.alias }}
          </div>
          <div v-if="item.description" class="caption grey--text mt-1">{{ item.description }}</div>
        </v-card-text>
      </v-card>
      <v-alert v-if="filteredCommands.length === 0" type="info" class="mt-2">
        Keine Commands gefunden.
      </v-alert>
    </template>
  </v-container>
</template>
<script>

import BackendService from '@/services/BackendService';

export default {
  name: 'CustomCommands',
  data: () => ({
    commands: [],
    saving: false,
    search: null,
    Rang: ['Everyone', 'Sub', 'Vip', 'Mod', 'Editor', 'Admin', 'Owner'],
    headers: [
      { text: 'Perm', value: 'perm', align: 'center' },
      { text: 'Command', value: 'command', align: 'center' },
      { text: 'Alias', value: 'alias', align: 'center' },
      { text: 'Description', value: 'description', sortable: false },
    ],
  }),
  computed: {
    filteredCommands() {
      if (!this.search) return this.commands;
      const s = this.search.toLowerCase();
      return this.commands.filter((c) => (c.command && c.command.toLowerCase().includes(s))
        || (c.perm && c.perm.toLowerCase().includes(s))
        || (c.description && c.description.toLowerCase().includes(s)));
    },
  },
  mounted() {
    BackendService.loadCommandList(this.$router.currentRoute.params.id).then((data) => {
      this.commands = data.data;
    }).catch(() => {});
  },
  methods: {
  },
};
</script>
<style>
.chipGroup label {
  font-size: 12px;
}

.cmd-label {
  color: #00ffcd;
  font-size: 1.1rem;
  font-weight: bold;
  word-break: break-all;
}
</style>
